import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { LAYER } from '../layers';
import { POPUP_IDS } from '../constants';
import { closePopupsAction } from '../store/actions';

const paramsMap = {
    logout: {
        exclude: [
            POPUP_IDS.PLAYER_FREEZE_ACCOUNT_POPUP,
            POPUP_IDS.LOGOUT_NOTIFICATION_POPUP,
            POPUP_IDS.USER_VERIFY_POPUP
        ]
    },
    gameLaunch: {
        excludeLayers: [
            LAYER.ADVANCED_PLAYER_MESSAGE,
            LAYER.ADVANCED_PLAYER_MESSAGE_MODAL,
            LAYER.LOGIN_MESSAGES,
            LAYER.DATA_VERIFICATION,
            LAYER.JUMIO
        ]
    }
};

export const useSmartClosePopups = () => {
    const dispatch = useDispatch();

    return useCallback((shortcutOrParams) => {
            const params = typeof shortcutOrParams === 'string'
                ? paramsMap[shortcutOrParams] || { popups: [shortcutOrParams] }
                : shortcutOrParams;

            dispatch(closePopupsAction(params));
        }, [dispatch]);
};
